module.exports = __webpack_public_path__ + "static/media/castel-back.08d262e3.jpg";